import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { login } from '../../redux/AuthSlice';
import { handleAPIRequest } from '../../api/api';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
  const { control, handleSubmit, setError } = useForm();
   const navigate = useNavigate();
const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (data) => {
    const { email, password } = data;
  
    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);
  
      const response = await handleAPIRequest('post', 'login', formData);
      if (response.success) {
        dispatch(
          login({
            user: response.data.user,
            token: response.data.token,
          })
        );

        localStorage.setItem('User', JSON.stringify(response.data.user));
        localStorage.setItem('authToken', response.data.token);

        toast.success(response.message || 'Login successful!');

        setTimeout(() => navigate('/dashboard'), 1000);
      } else {
        throw new Error(response.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login Error:', error);
  

      const errorMessage = error?.message || error.toString();
  
      if (errorMessage.includes('401')) {
        toast.error('Invalid email or password');
        setError('email', { type: 'manual', message: 'Invalid email or password' });
        setError('password', { type: 'manual', message: '' });
      } 
    //   else {
    //     toast.error('An unexpected error occurred. Please try again.');
    //   }
    }
  };
  


  return (
    <div className="bg-gray-100 flex items-center justify-center h-screen">
      <div className="bg-white w-full max-w-md p-8 rounded-lg shadow-lg">
        <div className="flex items-center justify-center p-3">
          {/* <img src={Logo} alt="AuditX Logo" className="w-52 h-44 mr-1" /> */}
          <h2 className="text-2xl font-bold text-center mb-6">Login</h2>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
          {/* Email Field */}
          <div>
            <label htmlFor="email" className="block text-gray-600 mb-2">Email</label>
            <Controller
              name="email"
              control={control}
              defaultValue=""
              rules={{
                required: 'Email is required',
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Invalid email address',
                },
              }}
              render={({ field, fieldState }) => (
                <>
                  <input
                    {...field}
                    type="email"
                    id="email"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
                      fieldState.error ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter your email"
                  />
                  {fieldState.error && (
                    <p className="text-red-500 text-sm mt-1">{fieldState.error.message}</p>
                  )}
                </>
              )}
            />
          </div>

          {/* Password Field */}
          <div className="relative">
            <label htmlFor="password" className="block text-gray-600 mb-2">Password</label>
            <Controller
              name="password"
              control={control}
              defaultValue=""
              rules={{
                required: 'Password is required',
                minLength: {
                  value: 6,
                  message: 'Password must be at least 6 characters long',
                },
              }}
              render={({ field, fieldState }) => (
                <>
                  <input
                    {...field}
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
                      fieldState.error ? 'border-red-500' : ''
                    }`}
                    placeholder="Enter your password"
                  />
                  <span
                    className="absolute right-3 top-11 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                  {fieldState.error && (
                    <p className="text-red-500 text-sm mt-1">{fieldState.error.message}</p>
                  )}
                </>
              )}
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-indigo-500 hover:bg-indigo-600 text-white font-bold py-2 rounded-lg transition duration-300"
          >
            Login
          </button>
        </form>


      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
